import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrowhead-w",
  "use": "app-icon-arrowhead-w-usage",
  "viewBox": "0 0 23 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 20\" id=\"app-icon-arrowhead-w\"><path d=\"M13 2l8 8-8 8M2 10h17\" stroke=\"#FFF\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol